module.exports = __webpack_public_path__ + "static/media/walle.39bec933.png";